import React, { useEffect, forwardRef } from 'react';
import Service from '../Networking/NetworkingUtils';
import { getCookie } from '../Utils/CookieHelper';
import { Toolbar, DialogActions, Tooltip, styled, Paper, CircularProgress, Typography, Box, Button, TableContainer, Table, TableHead, TableRow, TableCell, Dialog, DialogTitle, DialogContent, TextField, TableBody, Autocomplete, InputAdornment, ToggleButton, ToggleButtonGroup } from '@mui/material';
import moment from 'moment';
import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from '@mui/icons-material/Search';
import { json2excel } from 'js2excel';
import Row from './Row';
import AddBoxIcon from '@mui/icons-material/AddBox';
import SnackbarUtils from '../SnackbarUtils/SnackbarUtlis';


const token = getCookie("bb_metaverse_token");
var access = JSON.parse(getCookie("bb_metaverse_access"));
var user = JSON.parse(getCookie('bb_metaverse_user'))

const initialProjectData = {
  name: "",
  description: "",
  project_thumbnail: "",
  client: null,
  businessUnit: null,
};

const initialProjectErrors = {
  name: "",
  description: "",
  client: "",
  businessUnit: "",
};

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

const ProjectManagement = forwardRef((props, ref) => {
  const [row, setRow] = React.useState([]);
  const [dialogopen, setDialogopen] = React.useState(false);
  const [projectData, setProjectData] = React.useState(initialProjectData);
  const classes1 = useStyles();
  const [loading, setLoading] = React.useState(true);
  const [addDisabled, setAddDisabled] = React.useState(false)
  const [clientData, setClientData] = React.useState([]);
  const [businessUnits, setBusinessUnits] = React.useState([]);
  const [projectErrors, setProjectErrors] = React.useState(initialProjectErrors);
  const [search, setSearch] = React.useState('');
  const [projectStatus, setProjectStatus] = React.useState('active');

  const searchText = search.trim().toLowerCase();
  const filteredRows = searchText.length === 0 ? row : row.filter((project) => (
    project?.name?.toLowerCase().includes(searchText) ||
    project?.description?.toLowerCase().includes(searchText) ||
    project?.client_details?.name?.toLowerCase().includes(searchText) ||
    project?.business_unit_details?.name?.toLowerCase().includes(searchText) ||
    `${project?.first_name || ''} ${project?.last_name || ''}`.toLowerCase().includes(searchText)
  ));

  function validateProjectData() {
    const errors = {
      name: projectData.name.trim().length === 0 ? "Name is required" : "",
      description: projectData.description.trim().length === 0 ? "Description is required" : "",
      client: !projectData.client ? "Client is required" : "",
      businessUnit: !projectData.businessUnit ? "Business Unit is required" : "",
    };

    setProjectErrors(errors);
    return !Object.values(errors).some(Boolean);
  }

  function handleProjectDataChange(field, value) {
    setProjectData((previousProjectData) => ({
      ...previousProjectData,
      [field]: value,
    }))
    setProjectErrors((previousProjectErrors) => ({
      ...previousProjectErrors,
      [field]: "",
    }))
  }

  function handleClick() {
    setProjectData(initialProjectData)
    setProjectErrors(initialProjectErrors)
    setDialogopen(true)
  }
  function handleClose() {
    setProjectData(initialProjectData)
    setProjectErrors(initialProjectErrors)
    setDialogopen(false)
  }

  function Submit(e) {
    e.preventDefault();

    if (!validateProjectData()) {
      // this.props.enqueueSnackbar('Entries are not completely filled', {
      //   variant: 'warning'
      // })
      SnackbarUtils.warning('Please fill all required fields')
    } else {
      setAddDisabled(true)
      const dataobj = {};
      dataobj["name"] = projectData.name.trim();
      dataobj["description"] = projectData.description.trim();
      dataobj['project_thumbnail'] = projectData.project_thumbnail;
      dataobj['client'] = projectData.client.id;
      dataobj['client_id'] = projectData.client.id;
      dataobj['business_unit_id'] = projectData.businessUnit.id;
      dataobj['created_by'] = user.id

      Service.post('/api/projects/create_project/', {
        headers: {
          Authorization: "Token " + token
        },
        data: dataobj
      })
        .then(res => {
          // this.props.enqueueSnackbar('Data added successfully!', {
          //   variant: 'success'
          // })
          SnackbarUtils.success('Data added successfully!')
          getData();
          setAddDisabled(false)
          setDialogopen(false)
          setProjectData(initialProjectData);
          setProjectErrors(initialProjectErrors);


        })
        .catch(error => {
          setAddDisabled(false)
          console.log(error);
          // this.props.enqueueSnackbar('Something went wrong!', {
          //   variant: 'error'
          // })
          SnackbarUtils.error('Something went wrong!')
        });
    }
  }

  function getData(status = projectStatus) {
    const activeParam = `is_active=${status === 'active' ? 'True' : 'False'}`;
    let url = ''
    if (access && access.access && access.access.l0a.l0a_b) {
      url = `/api/projects/list_projects/?${activeParam}`
    } else {
      url = `/api/projects/get_manager_project/?${activeParam}`
    }
    Service.get(url, {
      headers: {
        Authorization: "Token " + token,
      },
    }).then(res => {
      setRow(res.data)
      setLoading(false)
    }).catch(error => {
      console.log(error)
      // this.props.enqueueSnackbar('Something went wrong!', {
      //   variant: 'error'
      // })
      setLoading(false)
      SnackbarUtils.error('Something went wrong!')
    })
  }

  function getClientData() {
    Service.get('/api/clients/get_client_details/', {
      headers: {
        Authorization: "Token " + token,
      },
    }).then(res => {
      setClientData(res.data)
    }).catch(error => {
      console.log(error)
      SnackbarUtils.error('Something went wrong!')
    })
  }

  function getBusinessUnits() {
    Service.get('/api/business/units/get_business_unit_details/', {
      headers: {
        Authorization: "Token " + token,
      },
    }).then(res => {
      setBusinessUnits(res.data)
    }).catch(error => {
      console.log(error)
      SnackbarUtils.error('Something went wrong!')
    })
  }

  useEffect(() => {
    if (access) {
      access = JSON.parse(getCookie("bb_metaverse_access"));
    }
    getClientData()
    getData()
    getBusinessUnits() 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleData() {
    setLoading(true)
    getData()
  }

  function handleProjectStatusChange(event, status) {
    if (status !== null) {
      setProjectStatus(status)
      setLoading(true)
      getData(status)
    }
  }

  function handleDownload() {

    let excelDataArray = JSON.parse(JSON.stringify(row));
    let jsonArray = []

    for (let i = 0; i < excelDataArray.length; i++) {
      let json = {}
      const element = excelDataArray[i];
      if (element) {

        json["Name"] = element.name
        json["Description"] = element.description
        json["Date created"] = moment(element.date_created).format("DD-MM-YYYY")
        json["Project Thumbnail"] = element.project_thumbnail
        json["Created by"] = element.last_name + ', ' + element.first_name

        jsonArray.push(json)
      }
    }

    try {
      json2excel({
        data: jsonArray,
        name: "Projects",
        formateDate: 'dd/mm/yyyy'
      });
    } catch (e) {
      console.error('export error');
    }
  }

  return (

    <div>
      {loading ? <Box display='flex' justifyContent={'center'} alignItems={'center'} width='100%'><CircularProgress /></Box> :
        <Paper className={classes1.paper}>
          <Toolbar sx={{ display: "flex", justifyContent: "space-between", m: 0, }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="h5">Projects</Typography>
              <ToggleButtonGroup
                color="primary"
                size="small"
                value={projectStatus}
                exclusive
                onChange={handleProjectStatusChange}
              >
                <ToggleButton value="active">Active</ToggleButton>
                <ToggleButton value="inactive">Inactive</ToggleButton>
              </ToggleButtonGroup>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <TextField
                size="small"
                autoComplete="off"
                label="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                }}
              />
              {(access && access.access && access.access.l0a.l0a_b) ? <Button disabled={addDisabled} onClick={handleClick}><Tooltip title="Add"><AddBoxIcon /></Tooltip></Button> : null}

              {(access && access.access && access.access.l0a.l0a_b) ? <Button onClick={handleDownload}><Tooltip title="Download"><DownloadIcon /></Tooltip></Button> : null}

            </Box>
          </Toolbar>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table" sx={{ tableLayout: 'center' }}>
              <TableHead>
                <TableRow align="center">
                  <TableCell align="left">Name</TableCell>
                  <TableCell align="left">Description</TableCell>
                  {/* <TableCell align="left">Thumbnail</TableCell> */}
                  <TableCell align="left">Client</TableCell>
                  <TableCell align="left">Business Unit</TableCell>
                  <TableCell align="left">Date Created</TableCell>
                  <TableCell align="left">Created By</TableCell>
                  <TableCell align="left">{access && access.access && access.access.l0a.l0a_b ? "Actions" : ""}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRows.length === 0 ?
                  <TableRow>
                    <TableCell align="center" colSpan={7}>
                      No Projects to Display
                    </TableCell>
                  </TableRow>
                  :

                  filteredRows.map((row) => (
                    <Row key={row.name} row={row} getProject={handleData} clientData={clientData} businessUnits={businessUnits} />
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

      }
      <Dialog maxWidth="xs" fullWidth={true} open={dialogopen} onClose={handleClose} >
        <DialogTitle marginTop="2px" spacing={2}>Add Project</DialogTitle>
        <DialogContent sx={{ gap: "12px", display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "column" }}>
          <TextField fullWidth autoComplete="off" variant="outlined" label="Name" value={projectData.name} error={Boolean(projectErrors.name)} helperText={projectErrors.name} onChange={(e) => { handleProjectDataChange('name', e.target.value) }}></TextField>
          <TextField fullWidth autoComplete="off" variant="outlined" label="Description" value={projectData.description} error={Boolean(projectErrors.description)} helperText={projectErrors.description} onChange={(e) => handleProjectDataChange('description', e.target.value)}></TextField>
          <Autocomplete
            fullWidth
            options={clientData ? clientData : []}
            value={projectData.client}
            getOptionLabel={(option) => option.name || ""}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, value) => handleProjectDataChange('client', value)}
            renderInput={(params) => <TextField {...params} label="Client" variant="outlined" error={Boolean(projectErrors.client)} helperText={projectErrors.client} />}
          />
          <Autocomplete
            fullWidth
            options={businessUnits ? businessUnits : []}
            value={projectData.businessUnit}
            getOptionLabel={(option) => option.name || ""}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, value) => handleProjectDataChange('businessUnit', value)}
            renderInput={(params) => <TextField {...params} label="Business Unit" variant="outlined" error={Boolean(projectErrors.businessUnit)} helperText={projectErrors.businessUnit} />}
          />
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="text" onClick={handleClose}>Cancel</Button>
          <Button color="primary" variant="text" onClick={(e) => Submit(e)}>Add</Button>
        </DialogActions>

      </Dialog>

    </div>
  );
})

export default ProjectManagement;
